import { Injectable } from "@angular/core";

@Injectable()
export class StorageService {
  /**
   * Set supplied item in localStorage
   * @param key
   * @param value
   * @return {StorageService}
   */
  setItem(key: string, value: any) {
    if (typeof value == "object") value = JSON.stringify(value);

    window.localStorage.setItem(key, value);
    return this;
  }

  /**
   * load item from localStorage or return Default Value if didn't find any
   * @param key
   * @param defaultValue
   * @return {any}
   */
  getItem(key: string, defaultValue: any = null) {
    let response = window.localStorage.getItem(key);
    if (response == null) return defaultValue;

    return response;
  }
}
